import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Shield, Users, Calendar, BarChart3 } from 'lucide-react';

const AdminDashboard = () => {
  const { user } = useAuth();

  return (
    <div className="max-w-6xl mx-auto">
      <div className="mb-8 flex items-center">
        <div className="p-3 bg-red-100 rounded-lg text-red-600 mr-4">
          <Shield className="h-8 w-8" />
        </div>
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Admin Dashboard</h1>
          <p className="text-gray-600">Welcome, {user?.name}. Manage the conference from here.</p>
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-6 mb-8">
        <Link to="/admin/users" className="card hover:shadow-lg transition-shadow cursor-pointer">
          <div className="flex items-center">
            <div className="p-3 bg-green-100 rounded-lg text-green-600 mr-4">
              <Users className="h-6 w-6" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900">User Management</h3>
              <p className="text-green-600 font-medium">View All Registrations</p>
            </div>
          </div>
        </Link>
        <Link 
          to="/admin/events" 
          className="card block hover:shadow-lg transition-shadow"
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <div className="p-3 bg-blue-100 rounded-lg text-blue-600 mr-4">
                <Calendar className="h-6 w-6" />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-900">Event Management</h3>
                <p className="text-blue-600 font-medium">Create, edit, duplicate, delete</p>
              </div>
            </div>
            <span className="text-sm text-blue-500 font-medium">
              Manage
            </span>
          </div>
        </Link>
        <div className="card">
          <div className="flex items-center">
            <div className="p-3 bg-purple-100 rounded-lg text-purple-600 mr-4">
              <BarChart3 className="h-6 w-6" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900">Analytics</h3>
              <p className="text-purple-600 font-medium">Coming Soon</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;


